import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"


const ResizableInput = React.forwardRef(({ className, ...props }, ref) => {
  const textareaRef = React.useRef(null)

  React.useImperativeHandle(ref, () => textareaRef.current)

  const adjustHeight = (el) => {
    if (!el) return
    el.style.height = "auto"
    el.style.height = el.scrollHeight + "px"
  }

  React.useEffect(() => {
    if (textareaRef.current) {
      adjustHeight(textareaRef.current)
    }
  }, [])

  const handleInput = (e) => {
    adjustHeight(e.currentTarget)
  }

  return (
    <textarea
      ref={textareaRef}
      rows={1}
      onInput={handleInput}
      className={cn(
        "flex w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors " +
          "placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring " +
          "disabled:cursor-not-allowed disabled:opacity-50 md:text-sm resize-none overflow-hidden",
        className
      )}
      {...props}
    />
  )
})


ResizableInput.displayName = "ResizableInput"



export { Input, ResizableInput }
